import { ImagePlus } from 'lucide-react'
import { MAX_CHAT_ATTACHMENTS } from '../hooks/usePendingAttachments'

/** Full-bleed "drop photos here" overlay shown while a file is dragged over a
 *  chat composer. Rendered only when dragging; pointer-events off so it never
 *  eats the drop. */
export function ChatDropOverlay({ pendingCount }: { pendingCount: number }) {
  return (
    <div className="pointer-events-none absolute inset-0 z-20 flex items-center justify-center rounded-[inherit] border-2 border-dashed border-acid bg-bg-2/90 backdrop-blur-sm">
      <div className="flex flex-col items-center gap-2 text-center text-paper">
        <ImagePlus size={32} className="text-acid" />
        <p className="text-[14px] font-medium">
          {pendingCount >= MAX_CHAT_ATTACHMENTS
            ? `Up to ${MAX_CHAT_ATTACHMENTS} photos per message`
            : 'Drop photos to add'}
        </p>
      </div>
    </div>
  )
}
